import { useContext, useEffect, useState, useRef } from "react"
import CategoryList from "./CategoryList"
import axios from "axios";
import AppConfig from "../AppConfig.js";
import { SpikerBoardContext } from "../context/SpikerBoardContext.js";
import { Divider } from "primereact";
import StartListCategory from "./StartListCategory.js";
import StartListStart from "./StartListStart.js";
import { HTime } from "../lib/HDateTime.js";

export default function StartListBox() {
    const [spikerBoardContext, setSpikerBoardContext] = useContext(SpikerBoardContext);
    const [categories, setCategories] = useState([]);
    const [startListCategoryPersons, setStartListaCategoryPersons] = useState([]);
    const [startListCategoryHeader, setStartListaCategoryHeader] = useState("");
    const [activeStartListCategory, setActiveStartListCategory] = useState(0);
    const eventStartTime = useRef(null);
    useEffect(() => {
        if (spikerBoardContext.event.ID < 0) return;
        //get start time
        eventStartTime.current = HTime.Parse(spikerBoardContext.eventSettings.starttime);

        let cHeader = spikerBoardContext.categories.find((el) => el.ID === activeStartListCategory);
        if (cHeader !== undefined) {
            setStartListaCategoryHeader(cHeader.Name);
        } else {
            //console.log("nie znalazłem header");
        }
        //get persons in category
        //filter_categoryId
        const headers = {
            'Content-Type': 'text/json; charset=UTF-8'
        }
        axios.get(AppConfig().Server.Hostname + "/persons?eid=" + spikerBoardContext.event.ID + "&filter_categoryId=" + activeStartListCategory, null, { headers }).then(
            (resp) => {
                setStartListaCategoryPersons(resp.data);
                //console.log("set persons... ", resp.data);
            }
        );
    }, [activeStartListCategory]);
    return (
        <div className="grid grid-cols-12 gap-2 h-full" >
            <div className="col-span-2">
                <CategoryList items={categories} onSetCategory={(id) => { setActiveStartListCategory(id) }} />
            </div>
            <div className="col-span-5 p-2  border-r-2 ">
                <StartListCategory categoryHeader={startListCategoryHeader} persons={startListCategoryPersons} starttime={eventStartTime.current} />
            </div>

            <div className="col-span-5 p-2">

                <StartListStart />
            </div>
        </div>
    )
}